// extracted by mini-css-extract-plugin
module.exports = {"avatar":"theme__avatar--3OjJz","image":"theme__image--2Ueo9","letter":"theme__letter--26GdB"};